import Main from '../views/Main';
import emptyView from '../components/menu/empty-view.vue';
import dashImg from '../assets/menu-img/dashboard.png';
import chargeImg from '../assets/menu-img/charge.png';
import custImg from '../assets/menu-img/cust.png';
import orderImg from '../assets/menu-img/order.png';
import caiwuImg from '../assets/menu-img/caiwu.png';
import fankuiImg from '../assets/menu-img/fankui.png';
import settingImg from '../assets/menu-img/setting.png';

let menuRouter = [];
/**
  菜单路由
  wk 2019-11-29
*/
menuRouter = [
	{
		path: '/dbManage',
		meta: {
			title: '仪表盘',
			type: 'noChild',// 单个的一级菜单
			//icon:'http://img.cdn.wxzhida.cn/zdj4/menu/dashboard.png'
			icon: dashImg
		},
		name: 'dbManage',
		component: Main,
		children: [
			{
				path: '/dashboard',
				name: 'dashboard',
				meta: {
					parent: ['dbManage'],
					current: ['dashboard'],
					title: '仪表盘',
				},
				component: resolve => {
					require(['../views/dashboard/index.vue'], resolve);
				}
			},
		]
	},

	// {
	// 	path: '/orderManage',
	// 	meta: {
	// 		title: '运营商管理',
	// 		type: 'noChild',// 单个的一级菜单
	// 		icon:'http://img.cdn.wxzhida.cn/zdj4/menu/dashboard.png'
	// 	},
	// 	name: 'dealerManage',
	// 	component: Main,
	// 	children: [
	// 		{
	// 			path: '/dealerManageList',
	// 			name: 'dealerManageList',
	// 			meta: {
	// 				parent: ['dealerManage'],
	// 				current: ['dealerManageList'],
	// 				title: '运营商管理',
	// 			},
	// 			component: resolve => {
	// 				require(['../views/dealer-manage/list.vue'], resolve);
	// 			}
	// 		},
	// 	]
	// },

	{
		path: '/chargeManage',
		meta: {
			title: '充电管理',
			type: 'hasChild',
			//icon:'http://img.cdn.wxzhida.cn/zdj4/menu/charge.png'
			icon: chargeImg
		},
		name: 'chargeManage',
		component: Main,
		children: [
			{
				path: '/pileStationList',
				name: 'pileStationList',
				meta: {
					parent: ['chargeManage'],
					current: ['pileStationList'],
					title: '电站管理',
				},
				component: resolve => {
					require(['../views/charging-manage/pile-station/list.vue'], resolve);
				}
			},
			{
				path: '/pileList',
				name: 'pileList',
				meta: {
					parent: ['chargeManage'],
					current: ['pileList'],
					title: '充电桩管理',
				},
				component: resolve => {
					require(['../views/charging-manage/pile/list.vue'], resolve);
				}
			},
			// {
			// 	path: '/pileModelList',
			// 	name: 'pileModelList',
			// 	meta: {
			// 		parent: ['chargeManage'],
			// 		current: ['pileModelList'],
			// 		title: '充电桩型号管理',
			// 	},
			// 	component: resolve => {
			// 		require(['../views/charging-manage/pile-model/list.vue'], resolve);
			// 	}
			// },
		]
	},
	{
		path: '/custManage',
		meta: {
			title: '客户管理',
			type: 'noChild',// 单个的一级菜单
			//icon:'http://img.cdn.wxzhida.cn/zdj4/menu/cust.png'
			icon: custImg
		},
		name: 'custManage',
		component: Main,
		children: [
			{
				path: '/custManageList',
				name: 'custManageList',
				meta: {
					parent: ['custManage'],
					current: ['custManageList'],
					title: '客户管理',
				},
				component: resolve => {
					require(['../views/cust-manage/list.vue'], resolve);
				}
			},
		]
	},
	{
		path: '/orderManage',
		meta: {
			title: '订单管理',
			type: 'noChild',// 单个的一级菜单
			//icon:'http://img.cdn.wxzhida.cn/zdj4/menu/order.png'
			icon: orderImg
		},
		name: 'orderManage',
		component: Main,
		children: [
			{
				path: '/orderManageList',
				name: 'orderManageList',
				meta: {
					parent: ['orderManage'],
					current: ['orderManageList'],
					title: '订单管理',
				},
				component: resolve => {
					require(['../views/order-manage/list.vue'], resolve);
				}
			},
		]
	},
	{
		name: "clearSettlement",
		path: "/clearSettlement",
		meta: {
			title: "清分结算管理",
			type: "hasChild", // 单个的一级菜单
			// icon:'http://img.cdn.wxzhida.cn/zdj4/menu/order.png'
			icon: orderImg,
		},
		component: Main,
		children: [
			// {
			// 	path: "/clearAccount",
			// 	name: "clearAccount",
			// 	meta: {
			// 		parent: ["clearSettlement"],
			// 		current: ["clearAccount"],
			// 		title: "清分账户",
			// 	},
			// 	component: (resolve) => {
			// 		require(["../views/clear-settlement/clear-account/index.vue"], resolve);
			// 	},
			// },
			{
				path: "/summaryTable",
				name: "summaryTable",
				meta: {
					parent: ["clearSettlement"],
					current: ["summaryTable"],
					title: "结算总表",
				},
				component: (resolve) => {
					require(["../views/clear-settlement/summary-table/index.vue"], resolve);
				},
			},
		],
	},
	{
		path: '/orderReconciliation',
		meta: {
			title: '订单对账',
			type: 'noChild',// 单个的一级菜单
			icon: orderImg
		},
		name: 'orderReconciliation',
		component: Main,
		children: [
			{
				path: '/orderReconciliationList',
				name: 'orderReconciliationList',
				meta: {
					parent: ['orderReconciliation'],
					current: ['orderReconciliationList'],
					title: '订单对账',
				},
				component: resolve => {
					require(['../views/order-reconciliation/list.vue'], resolve);
				}
			},
		]
	},
	{
		path: '/energyRecord',
		meta: {
			title: '补能充电记录',
			type: 'noChild',// 单个的一级菜单
			icon: orderImg
		},
		name: 'energyRecord',
		component: Main,
		children: [
			{
				path: '/energyRecordList',
				name: 'energyRecordList',
				meta: {
					parent: ['energyRecord'],
					current: ['energyRecordList'],
					title: '补能充电记录',
				},
				component: resolve => {
					require(['../views/energy-record/list.vue'], resolve);
				}
			},
		]
	},
	{
		path: '/dischargeRecord',
		meta: {
			title: '馈网放电服务',
			type: 'noChild',// 单个的一级菜单
			icon: orderImg
		},
		name: 'dischargeRecord',
		component: Main,
		children: [
			{
				path: '/dischargeRecordList',
				name: 'dischargeRecordList',
				meta: {
					parent: ['dischargeRecord'],
					current: ['dischargeRecordList'],
					title: '馈网放电服务',
				},
				component: resolve => {
					require(['../views/discharge-record/list.vue'], resolve);
				}
			},
		]
	},
	{
		path: '/financeManage',
		meta: {
			title: '财务管理',
			type: 'hasChild',
			//icon:'http://img.cdn.wxzhida.cn/zdj4/menu/caiwu.png'
			icon: caiwuImg
		},
		name: 'financeManage',
		component: Main,
		children: [
			{
				path: '/financialStatements',
				name: 'financialStatements',
				meta: {
					parent: ['financeManage'],
					current: ['financialStatements'],
					title: '财务报表',
				},
				component: resolve => {
					require(['../views/finance-manage/financial-statements/index.vue'], resolve);
				}
			},
			{
				path: '/withdrawalList',
				name: 'withdrawalList',
				meta: {
					parent: ['financeManage'],
					current: ['withdrawalList'],
					title: '提现管理',
				},
				component: resolve => {
					require(['../views/finance-manage/withdrawal/list.vue'], resolve);
				}
			},
			{
				path: '/cardList',
				name: 'cardList',
				meta: {
					parent: ['financeManage'],
					current: ['cardList'],
					title: '制卡管理',
				},
				component: resolve => {
					require(['../views/finance-manage/card/list.vue'], resolve);
				}
			},
			{
				path: "/stationReport",
				name: "stationReport",
				meta: {
					parent: ["financeManage"],
					current: ["stationReport"],
					title: "电站报表",
				},
				component: (resolve) => {
					require(["../views/finance-manage/station-report/list.vue"], resolve);
				},
			},
			{
                path: "/operatorSettlement",
                name: "operatorSettlement",
                meta: {
                    parent: ["financeManage"],
                    current: ["operatorSettlement"],
                    title: "运营商结算",
                },
                component: (resolve) => {
                    require(["../views/finance-manage/operator-settlement/list.vue"], resolve);
                },
            }
		]
	},
	{
		path: '/serviceFeedback',
		meta: {
			title: '服务和反馈',
			type: 'hasChild',
			//icon:'http://img.cdn.wxzhida.cn/zdj4/menu/fankui.png'
			icon: fankuiImg
		},
		name: 'serviceFeedback',
		component: Main,
		children: [
			{
				path: '/feedbackRouter',
				name: 'feedbackRouter',
				meta: {
					parent: ['serviceFeedback'],
					current: ['feedbackRouter'],
					title: '桩到家运营论坛',
				},
				component: resolve => {
					require(['../views/service-feedback/index.vue'], resolve);
				}
			},
			// {
			// 	path: '/serviceRecordList',
			// 	name: 'serviceRecordList',
			// 	meta: {
			// 		parent: ['serviceFeedback'],
			// 		current: ['serviceRecordList'],
			// 		title: '服务记录',
			// 	},
			// 	component: resolve => {
			// 		require(['../views/service-record/list.vue'], resolve);
			// 	}
			// },
		]
	},
	{
		path: '/systemManage',
		meta: {
			title: '系统管理',
			type: 'hasChild',
			//icon:'http://img.cdn.wxzhida.cn/zdj4/menu/setting.png'
			icon: settingImg
		},
		name: 'systemManage',
		component: Main,
		children: [
			{
				path: '/userManageList',
				name: 'user_list',
				meta: {
					parent: ['systemManage'],
					current: ['user_list'],
					title: '用户管理',
				},
				component: resolve => {
					require(['../views/system-manage/user-manage/list.vue'], resolve);
				}
			},
			{
				path: '/roleManageList',
				name: 'role_list',
				meta: {
					parent: ['systemManage'],
					current: ['role_list'],
					title: '角色管理',
				},
				component: resolve => {
					require(['../views/system-manage/role-manage/list.vue'], resolve);
				}
			},
			{
				path: "/operationLog",
				name: "operationLog",
				meta: {
					parent: ["systemManage"],
					current: ["operationLog"],
					title: "操作日志",
				},
				component: (resolve) => {
					require([
						"../views/system-manage/operation-log/list.vue",
					], resolve);
				},
			},
		]
	},
]

export default menuRouter;
